export default "__VITE_ASSET__CYWvxsbV__"